import React, {Component} from 'react';
import Title from './Title';
import Slider from 'react-slick';

class Demo extends Component {
    render() {
        const settings = {
            dots: true,
            infinite: true,
            speed: 500,
            arrows: false,
            autoplay: true,
            pauseOnHover: true,
            autoplaySpeed: 2500,
            slidesToShow: 2,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        infinite: true,
                        dots: true
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        initialSlide: 2
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        };
        return (
            <section className="portfolio_slider_area" id="demo">
                <div className="container">
                    <Title tCenter="text-center" stitle="Marketplace" btitle="Demo projects"/>
                    <Slider {...settings} className="portfolio_slider">
                        
                        <div className="p_item">
                            <div className="portfolio_content">
                                <a href="/demo2"><img src={require('../image/demo-thumbnails/tetris.png')} alt=""/></a>
                                <div className="text">
                                    <a href="/demo2"><h4>Tetris</h4></a>
                                    <a href="/demo2">C++ implementation of the classic Tetris game</a>
                                </div>
                            </div>
                        </div>
                        <div className="p_item">
                            <div className="portfolio_content">
                                <a href="/demo1"><img src={require('../image/demo-thumbnails/mnist.png')} alt=""/></a>
                                <div className="text">
                                <a href="/demo1"><h4>MNIST Classifier</h4></a>
                                <a href="/demo1"> Handwritten digit classifier</a>
                                </div>
                            </div>
                        </div>
                        
                    </Slider>
                </div>
            </section>
        )
    }
}

export default Demo;
